import applicationConfig from './application_config';

export default { applicationConfig };
